
import { Link } from 'react-router-dom';
import './styles.css'
import * as FcIcons from 'react-icons/fc';
import { useForm } from 'react-hook-form';
import React, { Fragment, useState, useEffect } from 'react'
import * as VscIcons from 'react-icons/vsc';
import { Modal, Button } from "react-bootstrap";
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps'
import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
const API_PATH = "firms";
const GOOGLE_MAP_API_KEY = "AIzaSyBLoal-kZlb6tO5aDvkJTFC0a4WMp7oHUM"; //AIzaSyA8oEXVIh8RoYuGQO-J0-iMEAL0wQGYSU8

const WrappedMap = withScriptjs(withGoogleMap(List));

export default function firmMap() {

  return (
    <div style={{ width: '70vw', height: '60vh', position: 'absolute', left: 270, zIndex: 1001 }}>
      <h1 style={{ textAlign: 'center' }}>Firms</h1>
      <Link to={`/firms/add`} className="btn btn-sm btn-success mb-2"> Add Firm </Link>
      <WrappedMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${GOOGLE_MAP_API_KEY}`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: "100%" }} />}
      />

    </div>
  )
}

function List(match) {
  const { path } = match;
  const [firms, setFirms] = useState(null);
  const [results, setResults] = useState(0);
  const [selectedFirm, setSelectedFirm] = useState(null);
  const [deleteId, setDeleteId] = useState(0);
  const [show, setShow] = useState(false);
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);

  const handleClose = () => {
    setShow(false);
    console.log("close");
  };

  const confirmDelete = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  function deleteFirm() {
    console.log("deleting firm id: " + deleteId);
    setFirms(firms.map(x => {
      if (x.id === deleteId) { x.isDeleting = true; }
      return x;
    }));
    AxiosService.delete(API_PATH, deleteId).then(() => {
      setFirms(firms => firms.filter(x => x.id !== deleteId));
    });
    setShow(false);
  };

  const { register, watch, formState: { errors }, handleSubmit } = useForm();

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => setFirms(x.data) & setResults(x.data.length));
  }, []);

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      var queries = x.data.filter(item => item.name.toLowerCase().includes(keyword))
      setFirms(queries)
      setResults(queries.length)
    }
    );
  }

  return (

    <Fragment >

      <GoogleMap
        defaultZoom={6}
        defaultCenter={{ lat: 38.907192, lng: -77.036873 }}
      >
        {firms && firms.map(firm =>
          <Marker
            key={firm.id}
            id={firm.id}
            position={{
              lat: firm.latitude,
              lng: firm.longitude
            }}
            onClick={() =>
              setSelectedFirm(firm)


            }
          // icon={{
          //   url: './gavel.png',
          //   scaledSize: new window.google.maps.Size(25, 25)
          // }}
          />
        )}
        {selectedFirm &&
          <InfoWindow position={{
            lat: selectedFirm.latitude,
            lng: selectedFirm.longitude
          }}

            onCloseClick={() => {
              setSelectedFirm(null);
            }}


          >


            <div style={{ marginRight: '.5rem' }} className="pickle">
              <h4 style={{ fontWeight: 'bold' }}>{selectedFirm.name} {' '} </h4>
              <p>{selectedFirm.street},{selectedFirm.city},{selectedFirm.state}</p>
              {/* <p>{selectedFirm.website}</p> */}
              {selectedFirm.website && <td><a target="_blank" rel="noreferrer noopener" href={"https://" + selectedFirm.website}>{selectedFirm.website} </a><p> </p></td>}

              <Link to={`/firms/view/${selectedFirm.id}`} className="btn btn-sm btn-info"> <VscIcons.VscOpenPreview size={12} /> View {selectedFirm.name} <br></br></Link>
              <p> </p>

            </div>
          </InfoWindow>
        }

      </GoogleMap>

      <br>
      </br>
      <div className='pickle' style={{ zIndex: -1 }}>
        <form onSubmit={handleSubmit(search)} onReset={useEffect}>
          <div className="form-row">
            <div className="form-group col-5">
              <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
              <div className="invalid-feedback">{errors.query?.message}</div>
            </div>
            <div className="form-group col-5">
              {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
              <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
            </div>
          </div>
        </form>
        <text>Results: {results}</text>
        <table className="table-crunch table table-bordered table-responsive table-hover table-hover-cursor">
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Firm Name</th>
              <th style={{ width: '25%' }}>Address</th>
              <th style={{ width: '25%' }}>Website</th>
              <th style={{ width: '25%' }}>Attorneys</th>
            </tr>
          </thead>
          <tbody>
            {firms && firms.map(firm =>
              <tr onClick={() =>
                setSelectedFirm(firm)

              } key={firm.id}>
                <td>{firm.name}</td>
                <td>{firm.street}, {firm.city}, {firm.state}, {firm.zip}</td>
                <td><a target="_blank" rel="noreferrer noopener" href={"https://" + firm.website}>{firm.website} </a></td>
                {firm.attorneys && firm.attorneys.map(attorney =>
                  <td key={attorney.id} style={{ display: 'flex' }}>
                    <Link to={`/attorneys/view/${attorney.id}`} className="btn btn-sm btn-info mr-1" > {attorney.name} </Link>
                  </td>
                )}
                <td style={{ whiteSpace: 'nowrap' }}>

                  <Link to={`/firms/view/${firm.id}`} className="btn btn-sm btn-info mr-2"> View </Link>

                  {(mod || admin) && (
                    <Link to={`/firms/edit/${firm.id}`} className="btn btn-sm btn-primary mr-2"> Edit </Link>
                  )}
                  {admin && (
                    <button
                      className="btn btn-sm btn-danger mr-2"
                      onClick={() => confirmDelete(firm.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            )}
            {!firms &&
              <tr>
                <td colSpan="4" className="text-center">
                  <div className="spinner-border spinner-border-lg align-center"></div>
                </td>
              </tr>
            }
            {firms && !firms.length &&
              <tr>
                <td colSpan="4" className="text-center">
                  <div className="p-2">No Firms To Display</div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete?</Modal.Title>
          </Modal.Header>
          <Modal.Body>Would you like to delete this firm?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => deleteFirm(deleteId)}>
              OK
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Fragment>
  );
}

export { List };